"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setDichiarazioneScopoRichiediFido = exports.setPresaVisioneInformativaRichiediFido = exports.setPresaVisioneInformativaEnabledRichiediFido = exports.esportaRichiestaFidoPDF = exports.stampaInformativaRichiestaFidoIsiDispo = exports.setFidoIsiDispoArrayCartePossedute = exports.setFidoIsiDispoArrayRapportoDiLavoro = exports.setFidoIsiDispoArrayDettaglioProfessione = exports.setFidoIsiDispoArrayCategoriaAutonomi = exports.setFidoIsiDispoArrayCategoriaLiberiProfessionisti = exports.setFidoIsiDispoArrayCategoriaDocenti = exports.setFidoIsiDispoArrayCategoriaMilitari = exports.setFidoIsiDispoArrayCategoriaDipendenti = exports.setFidoIsiDispoArrayCategoriaInattivi = exports.setFidoIsiDispoArrayCategoriaProfessione = exports.setFidoIsiDispoArraySituazioneAbitativa = exports.setFidoIsiDispoArrayStatoCivile = exports.resetEsitoFidoIsiDispo = exports.resetRiepilogoFidoIsiDispo = exports.resetFidoIsiDispo = exports.setFidoIsiDispoStep = exports.setFidoIsiDispoFormSubmitted = exports.setFidoIsiDispoCarteDiCreditoPossedute = exports.setFidoIsiDispoAltriImpegni = exports.setFidoIsiDispoImpegniMensiliAffitti = exports.setFidoIsiDispoOneriMensiliCrediti = exports.setFidoIsiDispoAltriRedditiMensili = exports.setFidoIsiDispoRedditoNettoMensile = exports.setFidoIsiDispoAccreditoDomiciliatoPressoBanca = exports.setFidoIsiDispoAnnoDiInizio = exports.setFidoIsiDispoRapportoDiLavoro = exports.setFidoIsiDispoDatoreDiLavoro = exports.setFidoIsiDispoCategoriaAutonomi = exports.setFidoIsiDispoCategoriaLiberiProfessionisti = exports.setFidoIsiDispoCategoriaDocenti = exports.setFidoIsiDispoCategoriaMilitari = exports.setFidoIsiDispoCategoriaDipendenti = exports.setFidoIsiDispoCategoriaInattivi = exports.setFidoIsiDispoDettaglioProfessione = exports.setFidoIsiDispoCategoriaProfessionale = exports.setFidoIsiDispoSituazioneAbitativa = exports.setFidoIsiDispoNumeroFigli = exports.setFidoIsiDispoNumeroAdulti = exports.setFidoIsiDispoStatoCivile = exports.setFidoIsiDispoMassimaleTransazione = exports.setFidoIsiDispoRapportoSelezionato = exports.autorizzaRichiestaFidoIsiDispo = exports.getInfoDispositivaRichiediFidoIsiDispo = exports.controlloRichiediFidoIsiDispo = exports.getParametriRichiediFidoIsiDispo = void 0;
exports.setStepMassimaleRichiediFido = exports.setMassimaleMinRichiediFido = exports.setMassimaleMaxRichiediFido = void 0;
const api_rest_1 = require("@sparkasse/api-rest");
const __1 = require("..");
const general_1 = require("../general");
const general_configuration_1 = require("../general/general.configuration");
const helpers_1 = require("../helpers");
//* get parametri richiedi fido isi dispo - START */
function getParametriRichiediFidoIsiDispoStart() {
    return {
        type: __1.EReduxActionTypes.RICHIEDI_FIDO_ISI_DISPO_GET_PARAMETRI_START
    };
}
function getParametriRichiediFidoIsiDispoSuccess(payload) {
    return {
        type: __1.EReduxActionTypes.RICHIEDI_FIDO_ISI_DISPO_GET_PARAMETRI_SUCCESS,
        payload
    };
}
function generalError(value, showGenericModalError, sendErrorToMatomo) {
    return async (dispatch) => {
        dispatch((0, __1.setError)(value, showGenericModalError));
        !!sendErrorToMatomo && sendErrorToMatomo('RICHIEDI_ISI_DISPO', `code_error RICHIEDI_ISI_DISPO ${value.status} / ${value === null || value === void 0 ? void 0 : value.message} / ${value === null || value === void 0 ? void 0 : value.timestamp}`, 'ESITO_DISPOSITIVA');
    };
}
const getParametriRichiediFidoIsiDispo = () => async (dispatch, _, extraArguments) => {
    dispatch((0, __1.setLoader)(true));
    dispatch(getParametriRichiediFidoIsiDispoStart());
    if (extraArguments.mock) {
        dispatch((0, __1.setLoader)(false));
    }
    else {
        extraArguments.getItem('jwt').then((jwt) => {
            new api_rest_1.IsiDispoControllerApi((0, general_configuration_1.default)(api_rest_1.Configuration, extraArguments, undefined, jwt))
                .parametriIsiDispo().then((response) => {
                var _a;
                dispatch(getParametriRichiediFidoIsiDispoSuccess(response));
                ((_a = response.rapporti) === null || _a === void 0 ? void 0 : _a.length) === 0 && dispatch((0, __1.setNoRapporti)({ type: __1.TypeNoRapporti.FIDO }));
            }).catch(async (error) => {
                dispatch(generalError(await (0, helpers_1.formatError)(error)));
            }).finally(() => {
                dispatch((0, __1.setLoader)(false));
            });
        });
    }
};
exports.getParametriRichiediFidoIsiDispo = getParametriRichiediFidoIsiDispo;
/* get parametri richiedi fido isi dispo - FINE */
//* controllo richiedi fido isi dispo - START */
function controlloRichiediFidoIsiDispoStart() {
    return {
        type: __1.EReduxActionTypes.RICHIEDI_FIDO_ISI_DISPO_CONTROLLO_START
    };
}
function controlloRichiediFidoIsiDispoSuccess(payload) {
    return {
        type: __1.EReduxActionTypes.RICHIEDI_FIDO_ISI_DISPO_CONTROLLO_SUCCESS,
        payload
    };
}
const controlloRichiediFidoIsiDispo = () => async (dispatch, getState, extraArguments) => {
    dispatch(setFidoIsiDispoFormSubmitted(true));
    const richiediFidoIsiDispoState = getState().richiediFidoIsiDispo;
    if ((0, __1.formValidFidoIsiDispo)(richiediFidoIsiDispoState)) {
        dispatch((0, __1.setLoader)(true));
        dispatch(controlloRichiediFidoIsiDispoStart());
        if (extraArguments.mock) {
            dispatch((0, __1.setLoader)(false));
        }
        else {
            const datiIn = getState().richiediFidoIsiDispo;
            const request = {
                prestitoDto: (0, __1.buildPrestito)(datiIn)
            };
            extraArguments.getItem('jwt').then((jwt) => {
                new api_rest_1.IsiDispoControllerApi((0, general_configuration_1.default)(api_rest_1.Configuration, extraArguments, undefined, jwt))
                    .controlloIsiDispo(request).then((response) => {
                    dispatch(controlloRichiediFidoIsiDispoSuccess(response));
                }).catch(async (error) => {
                    dispatch(generalError(await (0, helpers_1.formatError)(error)));
                }).finally(() => {
                    dispatch((0, __1.setLoader)(false));
                });
            });
        }
    }
};
exports.controlloRichiediFidoIsiDispo = controlloRichiediFidoIsiDispo;
/* controllo richiedi fido isi dispo - FINE */
//* get info richiedi fido isi dispo - START */
function getInfoDispositivaichiediFidoIsiDispoStart() {
    return {
        type: __1.EReduxActionTypes.RICHIEDI_FIDO_ISI_DISPO_GET_INFO_DISPOSITIVA_START
    };
}
function getInfoDispositivaRichiediFidoIsiDispoSuccess(payload) {
    return {
        type: __1.EReduxActionTypes.RICHIEDI_FIDO_ISI_DISPO_GET_INFO_DISPOSITIVA_SUCCESS,
        payload
    };
}
const getInfoDispositivaRichiediFidoIsiDispo = (idDispositiva, eseguiInit, chiamataUscente, offline) => async (dispatch, getState, extraArguments) => {
    dispatch((0, __1.setLoader)(true));
    dispatch(getInfoDispositivaichiediFidoIsiDispoStart());
    if (extraArguments.mock) {
        dispatch((0, __1.setLoader)(false));
    }
    else {
        const request = {
            idDispositiva: idDispositiva,
            chiamataUscente,
            eseguiInit,
            offline: !!offline
        };
        extraArguments.getItem('jwt').then((jwt) => {
            new api_rest_1.IsiDispoControllerApi((0, general_configuration_1.default)(api_rest_1.Configuration, extraArguments, undefined, jwt))
                .infoAutenticazioneIsiDispo(request).then((response) => {
                dispatch(getInfoDispositivaRichiediFidoIsiDispoSuccess(response));
            }).catch(async (error) => {
                dispatch(generalError(await (0, helpers_1.formatError)(error)));
            }).finally(() => {
                dispatch((0, __1.setLoader)(false));
            });
        });
    }
};
exports.getInfoDispositivaRichiediFidoIsiDispo = getInfoDispositivaRichiediFidoIsiDispo;
/* controllo richiedi fido isi dispo - FINE */
/* autorizza richiedi fido isi dispo - START */
function autorizzaRichiestaFidoIsiDispoStart() {
    return {
        type: __1.EReduxActionTypes.RICHIEDI_FIDO_ISI_DISPO_AUTORIZZA_START
    };
}
function autorizzaRichiestaFidoIsiDispoSuccess(payload) {
    return {
        type: __1.EReduxActionTypes.RICHIEDI_FIDO_ISI_DISPO_AUTORIZZA_SUCCESS,
        payload
    };
}
const autorizzaRichiestaFidoIsiDispo = (idDispositiva, credenziale) => async (dispatch, _, extraArguments) => {
    dispatch((0, __1.setLoader)(true));
    dispatch(autorizzaRichiestaFidoIsiDispoStart());
    if (extraArguments.mock) {
        dispatch((0, __1.setLoader)(false));
    }
    else {
        const getInfoDispositivaBonificoSepaRequest = {
            idDispositiva,
            credenzialeDispositivaDto: credenziale
        };
        extraArguments.getItem('jwt').then((jwt) => {
            new api_rest_1.IsiDispoControllerApi((0, general_configuration_1.default)(api_rest_1.Configuration, extraArguments, undefined, jwt))
                .autorizzaIsiDispo(getInfoDispositivaBonificoSepaRequest).then((response) => {
                dispatch(autorizzaRichiestaFidoIsiDispoSuccess(response));
                extraArguments.sendEventToMatomo('RICHIEDI_ISI_DISPO', `esito dispositiva RICHIEDI_ISI_DISPO ${response.stato}`, 'ESITO_DISPOSITIVA');
            }).catch(async (error) => {
                dispatch(generalError(await (0, helpers_1.formatError)(error), false, extraArguments.sendEventToMatomo));
            }).finally(() => {
                dispatch((0, __1.setLoader)(false));
            });
        });
    }
};
exports.autorizzaRichiestaFidoIsiDispo = autorizzaRichiestaFidoIsiDispo;
/* autorizza richiedi fido isi dispo - FINE */
function setFidoIsiDispoRapportoSelezionato(rapporto) {
    return {
        type: __1.EReduxActionTypes.RICHIEDI_FIDO_ISI_DISPO_SET_RAPPORTO_SELEZIONATO,
        payload: rapporto
    };
}
exports.setFidoIsiDispoRapportoSelezionato = setFidoIsiDispoRapportoSelezionato;
function setFidoIsiDispoMassimaleTransazione(number) {
    return {
        type: __1.EReduxActionTypes.RICHIEDI_FIDO_ISI_DISPO_SET_MASSIMALE_TRANSAZIONE,
        payload: number
    };
}
exports.setFidoIsiDispoMassimaleTransazione = setFidoIsiDispoMassimaleTransazione;
function setFidoIsiDispoStatoCivile(txt) {
    return {
        type: __1.EReduxActionTypes.RICHIEDI_FIDO_ISI_DISPO_SET_STATO_CIVILE,
        payload: txt
    };
}
exports.setFidoIsiDispoStatoCivile = setFidoIsiDispoStatoCivile;
function setFidoIsiDispoNumeroAdulti(number) {
    return {
        type: __1.EReduxActionTypes.RICHIEDI_FIDO_ISI_DISPO_SET_NUMERO_ADULTI,
        payload: number
    };
}
exports.setFidoIsiDispoNumeroAdulti = setFidoIsiDispoNumeroAdulti;
function setFidoIsiDispoNumeroFigli(number) {
    return {
        type: __1.EReduxActionTypes.RICHIEDI_FIDO_ISI_DISPO_SET_NUMERO_FIGLI,
        payload: number
    };
}
exports.setFidoIsiDispoNumeroFigli = setFidoIsiDispoNumeroFigli;
function setFidoIsiDispoSituazioneAbitativa(txt) {
    return {
        type: __1.EReduxActionTypes.RICHIEDI_FIDO_ISI_DISPO_SET_SITUAZIONE_ABITATIVA,
        payload: txt
    };
}
exports.setFidoIsiDispoSituazioneAbitativa = setFidoIsiDispoSituazioneAbitativa;
function setFidoIsiDispoCategoriaProfessionale(txt) {
    return {
        type: __1.EReduxActionTypes.RICHIEDI_FIDO_ISI_DISPO_SET_CATEGORIA_PROFESSIONALE,
        payload: txt
    };
}
exports.setFidoIsiDispoCategoriaProfessionale = setFidoIsiDispoCategoriaProfessionale;
function setFidoIsiDispoDettaglioProfessione(txt) {
    return {
        type: __1.EReduxActionTypes.RICHIEDI_FIDO_ISI_DISPO_SET_DETTAGLIO_PROFESSIONE,
        payload: txt
    };
}
exports.setFidoIsiDispoDettaglioProfessione = setFidoIsiDispoDettaglioProfessione;
function setFidoIsiDispoCategoriaInattivi(txt) {
    return {
        type: __1.EReduxActionTypes.RICHIEDI_FIDO_ISI_DISPO_SET_CATEGORIA_INATTIVI,
        payload: txt
    };
}
exports.setFidoIsiDispoCategoriaInattivi = setFidoIsiDispoCategoriaInattivi;
function setFidoIsiDispoCategoriaDipendenti(txt) {
    return {
        type: __1.EReduxActionTypes.RICHIEDI_FIDO_ISI_DISPO_SET_CATEGORIA_DIPENDENTI,
        payload: txt
    };
}
exports.setFidoIsiDispoCategoriaDipendenti = setFidoIsiDispoCategoriaDipendenti;
function setFidoIsiDispoCategoriaMilitari(txt) {
    return {
        type: __1.EReduxActionTypes.RICHIEDI_FIDO_ISI_DISPO_SET_CATEGORIA_MILITARI,
        payload: txt
    };
}
exports.setFidoIsiDispoCategoriaMilitari = setFidoIsiDispoCategoriaMilitari;
function setFidoIsiDispoCategoriaDocenti(txt) {
    return {
        type: __1.EReduxActionTypes.RICHIEDI_FIDO_ISI_DISPO_SET_CATEGORIA_DOCENTI,
        payload: txt
    };
}
exports.setFidoIsiDispoCategoriaDocenti = setFidoIsiDispoCategoriaDocenti;
function setFidoIsiDispoCategoriaLiberiProfessionisti(txt) {
    return {
        type: __1.EReduxActionTypes.RICHIEDI_FIDO_ISI_DISPO_SET_CATEGORIA_LIBERI_PROFESSIONISTI,
        payload: txt
    };
}
exports.setFidoIsiDispoCategoriaLiberiProfessionisti = setFidoIsiDispoCategoriaLiberiProfessionisti;
function setFidoIsiDispoCategoriaAutonomi(txt) {
    return {
        type: __1.EReduxActionTypes.RICHIEDI_FIDO_ISI_DISPO_SET_CATEGORIA_AUTONOMI,
        payload: txt
    };
}
exports.setFidoIsiDispoCategoriaAutonomi = setFidoIsiDispoCategoriaAutonomi;
function setFidoIsiDispoDatoreDiLavoro(txt) {
    return {
        type: __1.EReduxActionTypes.RICHIEDI_FIDO_ISI_DISPO_SET_DATORE_DI_LAVORO,
        payload: txt
    };
}
exports.setFidoIsiDispoDatoreDiLavoro = setFidoIsiDispoDatoreDiLavoro;
function setFidoIsiDispoRapportoDiLavoro(txt) {
    return {
        type: __1.EReduxActionTypes.RICHIEDI_FIDO_ISI_DISPO_SET_RAPPORTO_DI_LAVORO,
        payload: txt
    };
}
exports.setFidoIsiDispoRapportoDiLavoro = setFidoIsiDispoRapportoDiLavoro;
function setFidoIsiDispoAnnoDiInizio(txt) {
    return {
        type: __1.EReduxActionTypes.RICHIEDI_FIDO_ISI_DISPO_SET_ANNO_DI_INIZIO,
        payload: txt
    };
}
exports.setFidoIsiDispoAnnoDiInizio = setFidoIsiDispoAnnoDiInizio;
function setFidoIsiDispoAccreditoDomiciliatoPressoBanca(b) {
    return {
        type: __1.EReduxActionTypes.RICHIEDI_FIDO_ISI_DISPO_SET_ACCREDITO_DOMICILIATO_PRESSO_BANCA,
        payload: b
    };
}
exports.setFidoIsiDispoAccreditoDomiciliatoPressoBanca = setFidoIsiDispoAccreditoDomiciliatoPressoBanca;
function setFidoIsiDispoRedditoNettoMensile(number) {
    return {
        type: __1.EReduxActionTypes.RICHIEDI_FIDO_ISI_DISPO_SET_REDDITO_NETTO_MENSILE,
        payload: number
    };
}
exports.setFidoIsiDispoRedditoNettoMensile = setFidoIsiDispoRedditoNettoMensile;
function setFidoIsiDispoAltriRedditiMensili(number) {
    return {
        type: __1.EReduxActionTypes.RICHIEDI_FIDO_ISI_DISPO_SET_ALTRI_REDDITI_MENSILI,
        payload: number
    };
}
exports.setFidoIsiDispoAltriRedditiMensili = setFidoIsiDispoAltriRedditiMensili;
function setFidoIsiDispoOneriMensiliCrediti(number) {
    return {
        type: __1.EReduxActionTypes.RICHIEDI_FIDO_ISI_DISPO_SET_ONERI_MENSILI_CREDITI,
        payload: number
    };
}
exports.setFidoIsiDispoOneriMensiliCrediti = setFidoIsiDispoOneriMensiliCrediti;
function setFidoIsiDispoImpegniMensiliAffitti(number) {
    return {
        type: __1.EReduxActionTypes.RICHIEDI_FIDO_ISI_DISPO_SET_IMPEGNI_MENSILI_AFFITTI,
        payload: number
    };
}
exports.setFidoIsiDispoImpegniMensiliAffitti = setFidoIsiDispoImpegniMensiliAffitti;
function setFidoIsiDispoAltriImpegni(number) {
    return {
        type: __1.EReduxActionTypes.RICHIEDI_FIDO_ISI_DISPO_SET_ALTRI_IMPEGNI,
        payload: number
    };
}
exports.setFidoIsiDispoAltriImpegni = setFidoIsiDispoAltriImpegni;
function setFidoIsiDispoCarteDiCreditoPossedute(txt) {
    return {
        type: __1.EReduxActionTypes.RICHIEDI_FIDO_ISI_DISPO_SET_CARTE_DI_CREDITO_POSSEDUTE,
        payload: txt
    };
}
exports.setFidoIsiDispoCarteDiCreditoPossedute = setFidoIsiDispoCarteDiCreditoPossedute;
function setFidoIsiDispoFormSubmitted(b) {
    return {
        type: __1.EReduxActionTypes.RICHIEDI_FIDO_ISI_DISPO_SET_FORM_SUBMITTED,
        payload: b
    };
}
exports.setFidoIsiDispoFormSubmitted = setFidoIsiDispoFormSubmitted;
function setFidoIsiDispoStep(number) {
    return {
        type: __1.EReduxActionTypes.RICHIEDI_FIDO_ISI_DISPO_SET_STEP,
        payload: number
    };
}
exports.setFidoIsiDispoStep = setFidoIsiDispoStep;
function resetFidoIsiDispo() {
    return {
        type: __1.EReduxActionTypes.RICHIEDI_FIDO_ISI_DISPO_RESET
    };
}
exports.resetFidoIsiDispo = resetFidoIsiDispo;
function resetRiepilogoFidoIsiDispo() {
    return {
        type: __1.EReduxActionTypes.RICHIEDI_FIDO_ISI_DISPO_RESET_RIEPILOGO
    };
}
exports.resetRiepilogoFidoIsiDispo = resetRiepilogoFidoIsiDispo;
function resetEsitoFidoIsiDispo() {
    return {
        type: __1.EReduxActionTypes.RICHIEDI_FIDO_ISI_DISPO_RESET_ESITO
    };
}
exports.resetEsitoFidoIsiDispo = resetEsitoFidoIsiDispo;
function setFidoIsiDispoArrayStatoCivile(array) {
    return {
        type: __1.EReduxActionTypes.RICHIEDI_FIDO_ISI_DISPO_SET_ARRAY_STATO_CIVILE,
        payload: array
    };
}
exports.setFidoIsiDispoArrayStatoCivile = setFidoIsiDispoArrayStatoCivile;
function setFidoIsiDispoArraySituazioneAbitativa(array) {
    return {
        type: __1.EReduxActionTypes.RICHIEDI_FIDO_ISI_DISPO_SET_ARRAY_SITUAZIONE_ABITATIVA,
        payload: array
    };
}
exports.setFidoIsiDispoArraySituazioneAbitativa = setFidoIsiDispoArraySituazioneAbitativa;
function setFidoIsiDispoArrayCategoriaProfessione(array) {
    return {
        type: __1.EReduxActionTypes.RICHIEDI_FIDO_ISI_DISPO_SET_ARRAY_CATEGORIA_PROFESSIONE,
        payload: array
    };
}
exports.setFidoIsiDispoArrayCategoriaProfessione = setFidoIsiDispoArrayCategoriaProfessione;
function setFidoIsiDispoArrayCategoriaInattivi(array) {
    return {
        type: __1.EReduxActionTypes.RICHIEDI_FIDO_ISI_DISPO_SET_ARRAY_CATEGORIA_INATTIVI,
        payload: array
    };
}
exports.setFidoIsiDispoArrayCategoriaInattivi = setFidoIsiDispoArrayCategoriaInattivi;
function setFidoIsiDispoArrayCategoriaDipendenti(array) {
    return {
        type: __1.EReduxActionTypes.RICHIEDI_FIDO_ISI_DISPO_SET_ARRAY_CATEGORIA_DIPENDENTI,
        payload: array
    };
}
exports.setFidoIsiDispoArrayCategoriaDipendenti = setFidoIsiDispoArrayCategoriaDipendenti;
function setFidoIsiDispoArrayCategoriaMilitari(array) {
    return {
        type: __1.EReduxActionTypes.RICHIEDI_FIDO_ISI_DISPO_SET_ARRAY_CATEGORIA_MILITARI,
        payload: array
    };
}
exports.setFidoIsiDispoArrayCategoriaMilitari = setFidoIsiDispoArrayCategoriaMilitari;
function setFidoIsiDispoArrayCategoriaDocenti(array) {
    return {
        type: __1.EReduxActionTypes.RICHIEDI_FIDO_ISI_DISPO_SET_ARRAY_CATEGORIA_DOCENTI,
        payload: array
    };
}
exports.setFidoIsiDispoArrayCategoriaDocenti = setFidoIsiDispoArrayCategoriaDocenti;
function setFidoIsiDispoArrayCategoriaLiberiProfessionisti(array) {
    return {
        type: __1.EReduxActionTypes.RICHIEDI_FIDO_ISI_DISPO_SET_ARRAY_CATEGORIA_LIBERI_PROFESSIONISTI,
        payload: array
    };
}
exports.setFidoIsiDispoArrayCategoriaLiberiProfessionisti = setFidoIsiDispoArrayCategoriaLiberiProfessionisti;
function setFidoIsiDispoArrayCategoriaAutonomi(array) {
    return {
        type: __1.EReduxActionTypes.RICHIEDI_FIDO_ISI_DISPO_SET_ARRAY_CATEGORIA_AUTONOMI,
        payload: array
    };
}
exports.setFidoIsiDispoArrayCategoriaAutonomi = setFidoIsiDispoArrayCategoriaAutonomi;
function setFidoIsiDispoArrayDettaglioProfessione(array) {
    return {
        type: __1.EReduxActionTypes.RICHIEDI_FIDO_ISI_DISPO_SET_ARRAY_DETTAGLIO_PROFESSIONE,
        payload: array
    };
}
exports.setFidoIsiDispoArrayDettaglioProfessione = setFidoIsiDispoArrayDettaglioProfessione;
function setFidoIsiDispoArrayRapportoDiLavoro(array) {
    return {
        type: __1.EReduxActionTypes.RICHIEDI_FIDO_ISI_DISPO_SET_ARRAY_RAPPORTO_DI_LAVORO,
        payload: array
    };
}
exports.setFidoIsiDispoArrayRapportoDiLavoro = setFidoIsiDispoArrayRapportoDiLavoro;
function setFidoIsiDispoArrayCartePossedute(array) {
    return {
        type: __1.EReduxActionTypes.RICHIEDI_FIDO_ISI_DISPO_SET_ARRAY_CARTE_POSSEDUTE,
        payload: array
    };
}
exports.setFidoIsiDispoArrayCartePossedute = setFidoIsiDispoArrayCartePossedute;
const stampaInformativaRichiestaFidoIsiDispo = (allegato) => async (dispatch, _, extraArguments) => {
    var _a, _b;
    dispatch((0, __1.setLoader)(true));
    if (extraArguments.platform === 'mobile') {
        (0, helpers_1.downloadFile)(extraArguments, (_a = allegato.nomeFile) !== null && _a !== void 0 ? _a : '', (_b = allegato.data) !== null && _b !== void 0 ? _b : '');
    }
    if (extraArguments.platform === 'desktop' && allegato.data && allegato.contentType) {
        (0, helpers_1.hadlePdfResponse)(allegato.data, (url) => dispatch((0, general_1.popUpBlockedPdf)(url)));
    }
    dispatch((0, __1.setLoader)(false));
};
exports.stampaInformativaRichiestaFidoIsiDispo = stampaInformativaRichiestaFidoIsiDispo;
// export pdf richiesta fido - start
function esportaRichiestaFidoPDFStart() {
    return {
        type: __1.EReduxActionTypes.RICHIEDI_FIDO_ISI_DISPO_ESPORTA_PDF_RICHIESTA_FIDO_START
    };
}
function esportaRichiestaFidoPDFSuccess(payload) {
    return {
        type: __1.EReduxActionTypes.RICHIEDI_FIDO_ISI_DISPO_ESPORTA_PDF_RICHIESTA_FIDO_SUCCESS,
        payload
    };
}
const esportaRichiestaFidoPDF = (share, title, message) => async (dispatch, getState, extraArguments) => {
    var _a, _b;
    dispatch((0, __1.setLoader)(true));
    dispatch(esportaRichiestaFidoPDFStart());
    if (extraArguments.mock) {
        dispatch((0, __1.setLoader)(false));
    }
    else {
        const esportaDettaglioPDFRequest = {
            prestitoDto: (_b = (_a = getState().richiediFidoIsiDispo.esito) === null || _a === void 0 ? void 0 : _a.disposizione) !== null && _b !== void 0 ? _b : (0, api_rest_1.PrestitoDtoFromJSON)({})
        };
        extraArguments.getItem('jwt').then((jwt) => {
            new api_rest_1.IsiDispoControllerApi((0, general_configuration_1.default)(api_rest_1.Configuration, extraArguments, undefined, jwt, 'application/pdf')).dettaglioRichiestaFidoIsiDispoPdf(esportaDettaglioPDFRequest).then((response) => {
                if (extraArguments.platform === 'desktop') {
                    (0, helpers_1.hadlePdfResponse)(response, (url) => dispatch((0, general_1.popUpBlockedPdf)(url)));
                }
                if (extraArguments.platform === 'mobile') {
                    (0, helpers_1.download_sharePDF)(extraArguments, 'DettaglioOrdine.pdf', response, share, title, message);
                }
                dispatch(esportaRichiestaFidoPDFSuccess(response));
            }).catch(async (error) => {
                dispatch(generalError(await (0, helpers_1.formatError)(error)));
            }).finally(() => {
                dispatch((0, __1.setLoader)(false));
            });
        });
    }
};
exports.esportaRichiestaFidoPDF = esportaRichiestaFidoPDF;
// export pdf richiesta fido - Fine
function setPresaVisioneInformativaEnabledRichiediFido(b) {
    return {
        type: __1.EReduxActionTypes.RICHIEDI_FIDO_ISI_DISPO_SET_PRESA_VISIONE_INFORMATIVA_ENABLED,
        payload: b
    };
}
exports.setPresaVisioneInformativaEnabledRichiediFido = setPresaVisioneInformativaEnabledRichiediFido;
function setPresaVisioneInformativaRichiediFido(b) {
    return {
        type: __1.EReduxActionTypes.RICHIEDI_FIDO_ISI_DISPO_SET_PRESA_VISIONE_INFORMATIVA,
        payload: b
    };
}
exports.setPresaVisioneInformativaRichiediFido = setPresaVisioneInformativaRichiediFido;
function setDichiarazioneScopoRichiediFido(b) {
    return {
        type: __1.EReduxActionTypes.RICHIEDI_FIDO_ISI_DISPO_SET_DICHIARAZIONE_SCOPO,
        payload: b
    };
}
exports.setDichiarazioneScopoRichiediFido = setDichiarazioneScopoRichiediFido;
function setMassimaleMaxRichiediFido(num) {
    return {
        type: __1.EReduxActionTypes.RICHIEDI_FIDO_ISI_DISPO_SET_MASSIMALE_MAX,
        payload: num
    };
}
exports.setMassimaleMaxRichiediFido = setMassimaleMaxRichiediFido;
function setMassimaleMinRichiediFido(num) {
    return {
        type: __1.EReduxActionTypes.RICHIEDI_FIDO_ISI_DISPO_SET_MASSIMALE_MIN,
        payload: num
    };
}
exports.setMassimaleMinRichiediFido = setMassimaleMinRichiediFido;
function setStepMassimaleRichiediFido(num) {
    return {
        type: __1.EReduxActionTypes.RICHIEDI_FIDO_ISI_DISPO_SET_STEP_MASSIMALE,
        payload: num
    };
}
exports.setStepMassimaleRichiediFido = setStepMassimaleRichiediFido;
